const form = {
  formId: "new-user-form",
  formField: {
    taxId: {
      name: "taxId",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    conpanyName: {
      name: "conpanyName",
      label: "Tên tổ chức cá nhân",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức cá nhân:",
      invalidMsg: "tên tổ chức cá nhân không hợp lệ",
    },
    sendTo: {
      name: "sendTo",
      label: "Kính gửi",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập nơi muốn gửi",
    },
    unit: {
      name: "unit",
      label: "Đơn vị tính",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập đơn vị tính",
    },
    address: {
      name: "address",
      label: "Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    creator: {
      name: "creator",
      label: "Người lập biểu",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người lập biểu",
    },
    chiefAccountant: {
      name: "chiefAccountant",
      label: "Kế toán trưởng",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập kế toán trưởng",
    },
    director: {
      name: "director",
      label: "Giám đốc",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập giám đốc",
    },
  },
};

export default form;
